"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudWallet = exports.CloudWalletEthersSigner = exports.LocalKey = exports.PassKey = exports.CloudWalletStore = exports.xpubToEthereumAddress = void 0;
const bip39 = __importStar(require("bip39"));
const ecies = __importStar(require("eciesjs"));
const elliptic = __importStar(require("elliptic"));
const crypto = __importStar(require("crypto-browserify"));
const properties_1 = require("@ethersproject/properties");
const address_1 = require("@ethersproject/address");
const utils = __importStar(require("./utils"));
const ethers_1 = require("ethers");
const moralis_1 = __importDefault(require("moralis"));
const assert_1 = __importDefault(require("assert"));
// import wasm from '@sonydice/nitro-enclave-attestation-document/nitro_enclave_attestation_document_bg.wasm';
const erc20Abi = [
    // Read-Only Functions
    "function balanceOf(address owner) view returns (uint256)",
    "function decimals() view returns (uint8)",
    "function symbol() view returns (string)",
    // Authenticated Functions
    "function transfer(address to, uint amount) returns (bool)",
    // Events
    "event Transfer(address indexed from, address indexed to, uint amount)"
];
;
function hexlify(arrayBuffer) {
    if (arrayBuffer == null) {
        return "null";
    }
    var digits = '0123456789ABCDEF';
    var bytes = new Uint8Array(arrayBuffer);
    var result = '';
    for (var i = 0; i < arrayBuffer.byteLength; i++) {
        result += digits[bytes[i] >> 4];
        result += digits[bytes[i] & 0x0F];
    }
    return result;
}
function Uint16BEToHex(value) {
    let b = new Buffer(2);
    b.writeUint16BE(value);
    return b.toString('hex');
}
function decryptBlob(blob_hex, aes_key) {
    let blob = Buffer.from(blob_hex, "hex");
    let cpk_len = blob[34];
    let user_id_len = blob[35 + cpk_len];
    let user_id = user_id_len ? blob.subarray(36 + cpk_len, user_id_len) + "" : 0;
    const nonce = Buffer.from('000000000000000000000000', 'hex');
    var decipher = crypto.createDecipheriv('aes-256-gcm', aes_key, nonce);
    console.log('aes_key = ' + aes_key.toString('hex'));
    console.log('blob part to decrypt = ' + Buffer.from(blob_hex, "hex").subarray(36 + cpk_len + user_id_len).toString('hex'));
    const decrypted = decipher.update(Buffer.from(blob_hex, "hex").subarray(36 + cpk_len + user_id_len, blob.length - 16), null, null);
    //decipher.setAAD(null);
    decipher.setAuthTag(blob.subarray(blob.length - 16));
    decipher.final();
    return Buffer.concat([Buffer.from(blob_hex, "hex").subarray(0, 36 + cpk_len + user_id_len), decrypted]).toString('hex');
}
function xpubToEthereumAddress(xpub) {
    const node = ethers_1.ethers.HDNodeWallet.fromExtendedKey(xpub);
    return ethers_1.ethers.computeAddress(node.publicKey);
}
exports.xpubToEthereumAddress = xpubToEthereumAddress;
/**
 * Simple class to store and read wallets from localStorage
 */
class CloudWalletStore {
    constructor(client) {
        this.client = client;
    }
    add(wallet) {
        console.log("CloudWalletStore.add(" + wallet + ")");
        let wallets = this.list();
        wallets.push(wallet);
        localStorage.setItem("wallets", JSON.stringify(wallets));
    }
    list() {
        let wallets = [];
        let current = localStorage.getItem("wallets");
        if (current == null) {
            wallets = [];
        }
        else {
            let wallets_obj = JSON.parse(current);
            for (var wallet of wallets_obj) {
                wallets.push(CloudWallet.fromJSON(wallet, this.client));
            }
        }
        return wallets;
    }
    clear() {
        localStorage.setItem("wallets", "[]");
    }
}
exports.CloudWalletStore = CloudWalletStore;
/**
 * A PassKey that can be used by the Cloudwallet
 */
class PassKey {
    constructor(rawid, subjectPublicKeyInfo) {
        this.rawid = rawid;
        this.subjectPublicKeyInfo = subjectPublicKeyInfo;
    }
    type() {
        return "PassKey";
    }
    static async generate(name, displayName) {
        console.log("PassKey.generate(name=" + name, ", displayName=" + displayName + ")");
        var publicKeyCredentialCreationOptions = {
            challenge: Uint8Array.from("don't care", c => c.charCodeAt(0)),
            rp: {
                name: "Sony Web2 Cloudwallet", // spec say this name will pre presented to the user, but that does not seem to be the case
            },
            user: {
                id: Uint8Array.from("UZSL85T9AFC", c => c.charCodeAt(0)),
                name: name,
                displayName: displayName,
            },
            pubKeyCredParams: [{ alg: -7 /* ES256 */, type: "public-key" }],
            authenticatorSelection: {
                "residentKey": "preferred",
                "requireResidentKey": false,
                "userVerification": "preferred"
            },
            timeout: 60000,
            //           attestation: "none"
        };
        let credential = await navigator.credentials.create({
            publicKey: publicKeyCredentialCreationOptions
        });
        (0, assert_1.default)(credential != null);
        console.log(credential);
        let response = credential.response;
        console.log("Public key:" + hexlify(response.getPublicKey()));
        console.log("Public key algorithm:" + response.getPublicKeyAlgorithm());
        console.log("Public key transports:" + response.getTransports());
        console.log("Authenticator attachment: " + credential.authenticatorAttachment);
        return new PassKey(credential.rawId, response.getPublicKey());
    }
    async sign(digest) {
        console.log("Passkey.sign()");
        var publicKeyCredentialRequestOptions = {
            //challenge: Uint8Array.from(
            //"lalal", c => c.charCodeAt(0)),
            challenge: Buffer.from(digest, "hex"),
            allowCredentials: [{
                    id: this.rawid,
                    type: 'public-key',
                    transports: ['hybrid', 'internal']
                }],
            timeout: 60000,
        };
        let credential = await navigator.credentials.get({
            publicKey: publicKeyCredentialRequestOptions
        });
        if (credential != null) {
            console.log(credential);
            let response = credential.response;
            console.log("signature:" + hexlify(response.signature));
            console.log("authenticatorData:" + hexlify(response.authenticatorData));
            console.log("clientDataJSON:" + hexlify(response.clientDataJSON));
            return "01" + Uint16BEToHex(response.authenticatorData.byteLength) + hexlify(response.authenticatorData) +
                Uint16BEToHex(response.clientDataJSON.byteLength) + hexlify(response.clientDataJSON) +
                hexlify(response.signature); // 01 is used to indicate this is a "PassKey" signature
        }
        return "TODO";
    }
    toCOSEKeyHexlified() {
        // TODO: to check whether the x and y coordinate are always at the end of the subjectPublicKeyInfo
        let sec1_hexlified = Buffer.from(this.subjectPublicKeyInfo).toString('hex').slice(-130);
        (0, assert_1.default)(sec1_hexlified[0] === '0');
        (0, assert_1.default)(sec1_hexlified[1] === '4');
        const COSE_Key_hexlified = "A5010203262001215820" + sec1_hexlified.slice(2, 66) + "225820" + sec1_hexlified.slice(66); // skip 04, then take hexlified 32 bytes for x and same for y
        return COSE_Key_hexlified;
    }
    //
    // JSON (de)serializing
    //
    toJSON() {
        return {
            rawid_hex: Buffer.from(this.rawid).toString("hex"),
            subjectPublicKeyInfo_hex: Buffer.from(this.subjectPublicKeyInfo).toString("hex")
        };
    }
    static fromJSON(obj) {
        return new PassKey(Buffer.from(obj.rawid_hex, "hex"), Buffer.from(obj.subjectPublicKeyInfo_hex, "hex"));
    }
}
exports.PassKey = PassKey;
/**
 * A key that is created locally, in memory
 */
class LocalKey {
    static generate() {
        const ec = new elliptic.ec("p256");
        let keyPair = undefined;
        let devicePrivateKey = undefined;
        do {
            // generate client key pair
            keyPair = ec.genKeyPair();
            devicePrivateKey = keyPair.getPrivate('hex');
        } while (devicePrivateKey.length != 64);
        return new LocalKey(ec.keyFromPrivate(devicePrivateKey, "hex"));
    }
    constructor(keyPair) {
        this.keyPair = keyPair;
    }
    type() {
        return "LocalKey";
    }
    /**
     * Return the COSE Key representation, hexlified
     */
    toCOSEKeyHexlified() {
        // Dump the public key with the desired encoding: 04 + x + y
        const publicKey = this.keyPair.getPublic(false, "hex");
        // Convert publicKey to COSE_Key format
        // TODO: don't worry, I know what I am doing
        const COSE_Key_hexlified = "A5010203262001215820" + publicKey.slice(2, 66) + "225820" + publicKey.slice(66); // skip 04, then take hexlified 32 bytes for x and same for y
        return COSE_Key_hexlified;
    }
    //
    // JSON (de)serializing
    //
    toJSON() {
        return {
            privateKey_hex: this.keyPair.getPrivate("hex")
        };
    }
    static fromJSON(obj) {
        const ec = new elliptic.ec("p256");
        return new LocalKey(ec.keyFromPrivate(obj.privateKey_hex, "hex"));
    }
    /**
     * Sign the given digest (hexlified) and return the hexlified signature (hexlified concatenation of r and s)
     */
    async sign(digest) {
        const _signature = this.keyPair.sign(digest, "hex", { canonical: true });
        const req_signature = _signature.r.toString("hex").padStart(64, "0") + _signature.s.toString("hex").padStart(64, "0");
        return "00" + req_signature; // 00 is used to indicate this is a 'plain' signature
    }
    /**
     *
     * @returns A string containing the backup words for this wallet
     */
    getBackupWords() {
        return bip39.entropyToMnemonic(this.keyPair.getPrivate('hex'));
    }
    static restoreFromWords(words) {
        const privateKey = bip39.mnemonicToEntropy(words);
        const ec = new elliptic.ec("secp256k1");
        return new LocalKey(ec.keyFromPrivate(privateKey, "hex"));
    }
    static restoreFromKey(privateKey) {
        const ec = new elliptic.ec("secp256k1");
        return new LocalKey(ec.keyFromPrivate(privateKey, "hex"));
    }
    /**
     *
     * @returns The private key used to sign instructions related to this wallet, in hexadecimal
     */
    getPrivateKey() {
        return this.keyPair.getPrivate('hex');
    }
}
exports.LocalKey = LocalKey;
class CloudWalletEthersSigner extends ethers_1.AbstractSigner {
    constructor(cloudwallet, accountId, provider) {
        super(provider);
        this.cloudwallet = cloudwallet;
        this.accountId = accountId;
    }
    /**
     * Implementation of needed AbstractSigner methods. Took ethers.BaseWallet as example.
     */
    async getAddress() {
        return await this.cloudwallet.ethGetAddress(0);
    }
    async signTransaction(tx) {
        tx = (0, ethers_1.copyRequest)(tx);
        // Replace any Addressable or ENS name with an address
        const { to, from } = await (0, properties_1.resolveProperties)({
            to: (tx.to ? (0, ethers_1.resolveAddress)(tx.to, this.provider) : undefined),
            from: (tx.from ? (0, ethers_1.resolveAddress)(tx.from, this.provider) : undefined)
        });
        if (to != null) {
            tx.to = to;
        }
        if (from != null) {
            tx.from = from;
        }
        if (tx.from != null) {
            (0, ethers_1.assertArgument)((0, address_1.getAddress)((tx.from)) === await this.getAddress(), "transaction from address mismatch", "tx.from", tx.from);
            delete tx.from;
        }
        // Build the transaction
        const btx = ethers_1.Transaction.from(tx);
        console.log("btx.unsignedSerialized= " + btx.unsignedSerialized);
        console.log("btx.unsignedHash= " + btx.unsignedHash);
        btx.signature = await this.cloudwallet.signPayload(Buffer.from(btx.unsignedSerialized.slice(2), "hex")); // remove '0x' from unsignedSerialized
        return btx.serialized;
    }
    async signTypedData(domain, types, value) {
        // Populate any ENS names
        const populated = await ethers_1.TypedDataEncoder.resolveNames(domain, types, value, async (name) => {
            // @TODO: this should use resolveName; addresses don't
            //        need a provider
            ethers_1.ethers.assert(this.provider != null, "cannot resolve ENS names without a provider", "UNSUPPORTED_OPERATION", {
                operation: "resolveName",
                info: { name }
            });
            const address = await this.provider.resolveName(name);
            ethers_1.ethers.assert(address != null, "unconfigured ENS name", "UNCONFIGURED_NAME", {
                value: name
            });
            return address;
        });
        return await this.cloudwallet.signPayload(Buffer.from(ethers_1.TypedDataEncoder.encode(populated.domain, types, populated.value).slice(2), 'hex'));
    }
    /**
     * NOT IMPLEMENTED - DO NOT USE
     * @param message
     * @returns
     */
    async signMessage(message) {
        return Promise.reject("signMessage is not implemented for EthersSigner");
    }
    /**
     *
     * @param provider The provider to be used when interacting with the blockchain
     * @returns This signer object, with the provider set to the given value
     */
    connect(provider) {
        return new CloudWalletEthersSigner(this.cloudwallet, this.accountId, provider);
    }
}
exports.CloudWalletEthersSigner = CloudWalletEthersSigner;
/**
 * This class represents a crypto wallet that runs in the Cloud and is controlled through this client.
 */
class CloudWallet {
    /**
     *
     * @param id The id of the wallet
     * @param privateKey The private key which is used to sign instructions related to this wallet. Note: this is NOT the wallet private key
     * @param blob The blob that contains private information, including the wallet private key, encrypted with the enclave's MSK (master secret key)
     * @param client The HTTP client used to interact with the Cloud service.
     */
    constructor(id, signingKey, blob, client) {
        console.log("CloudWallet.constructor()");
        this.id = id;
        this.signingKey = signingKey;
        this.blob = blob;
        this.client = client;
        this.ethereumAddresses = new Map();
    }
    /**
     * Return an ethers Signer derived from the Cloudwallet
     * @param accountId Ethereum account to sign for
     * @param provider an ethers Provider
     * @returns an ethers Signer
     */
    getSigner(accountId, provider = null) {
        console.log("CloudWallet.getSigner()");
        return new CloudWalletEthersSigner(this, accountId, provider);
    }
    //
    // JSON (de)serializing
    //
    toJSON() {
        console.log("CloudWallet.toJSON()");
        return {
            id: this.id,
            signingKeyType: this.signingKey.type(),
            signingKey: this.signingKey.toJSON(),
            blob: this.blob,
            ethereumAddresses: Array.from(this.ethereumAddresses)
        };
    }
    static fromJSON(obj, client) {
        console.log("CloudWallet.fromJSON()");
        let signingKey = null;
        if (obj.signingKeyType === "LocalKey") {
            signingKey = LocalKey.fromJSON(obj.signingKey);
        }
        else if (obj.signingKeyType === "PassKey") {
            signingKey = PassKey.fromJSON(obj.signingKey);
        }
        let cloudwallet = new CloudWallet(obj.id, signingKey, obj.blob, client);
        if ("ethereumAddresses" in obj) {
            const ethereumAddresses = new Map(obj.ethereumAddresses);
            cloudwallet.ethereumAddresses = ethereumAddresses;
        }
        return cloudwallet;
    }
    /**
     * Returns the Ethereum address for given accountId
     */
    async ethGetAddress(accountId) {
        console.log("CloudWallet.ethGetAddress(" + accountId + ")");
        let address = this.ethereumAddresses.get(accountId);
        if (address !== undefined) {
            console.log("address (cached)= ", address);
            return address;
        }
        console.log("need to derive address from xpub");
        const xpub = await this.getXPub(accountId);
        address = xpubToEthereumAddress(xpub);
        console.log("address (from xpub)= ", address);
        this.ethereumAddresses.set(accountId, address);
        return address;
    }
    /**
     *
     * @param address The address of the wallet
     * @param words The backup words for this wallet
     * @param blob The blob for this wallet
     * @param provider The HTTP client used to communicate with the Cloud
     * @returns The restored wallet
     */
    /*
    static restoreFromWords(address: string, words: string, blob: string, provider: CloudWalletHttpClient): CloudWallet {
        const privateKey = bip39.mnemonicToEntropy(words);
        return new CloudWallet(address, privateKey, blob, provider);
    }
   */
    /**
     *
     * @param address The address of the wallet
     * @param privateKey The private key used to sign instructions related to this wallet, in hexadecimal
     * @param blob The blob for this wallet
     * @param provider The HTTP client used to communicate with the Cloud
     * @returns The restored wallet
     */
    /*
    static restoreFromKey(address: string, privateKey: string, blob: string, provider: CloudWalletHttpClient): CloudWallet {
        return new CloudWallet(address, privateKey, blob, provider);
    }
   */
    /**
     * Create a new wallet in the Cloud
     * @param client The HTTP client used to communicate with the Cloud
     * @returns The newly created wallet
     */
    static async createWallet(signingKey, client) {
        console.log("CloudWallet.createWallet()");
        return new Promise(async (resolve, reject) => {
            const COSE_Key_hexlified = signingKey.toCOSEKeyHexlified();
            // Now start the actual wallet creation...
            // Get the attestation report and verify it
            const report = await this.verifyAttestationReport(client, reject);
            // Convert enclave's pub key from compressed (as received) to uncompressed (expected by the "elliptic" module)
            const uncompressedEnclavePubKey = utils._compressedToUncompressedPubKey(report["publicKey"]);
            // build secret
            var secret = JSON.stringify({
                "clientPublicKey": COSE_Key_hexlified,
                "password": ""
            });
            secret = ecies.encrypt(uncompressedEnclavePubKey, Buffer.from(secret)).toString("hex");
            // build requestbody
            const body = JSON.stringify({
                "clientPublicKey": COSE_Key_hexlified,
                "secret": secret,
                "lang": "english",
                "userId": "",
                "wordNum": 12,
            });
            // build encKey header
            const aes_key = crypto.randomBytes(32);
            const req_encKey = ecies.encrypt(uncompressedEnclavePubKey, aes_key).toString("hex");
            // build signature header
            const digestToSign = crypto.createHash('sha256').update(Buffer.from(body)).update(Buffer.from(req_encKey)).digest("hex");
            const req_signature = await signingKey.sign(digestToSign);
            // Use the client to make the REST call
            const res = await client.createWallet(body, req_signature, req_encKey);
            const response = await res.text();
            const signature = res.headers.get("X-Enclave-Signature") + "";
            // Verify enclave response signature
            this.verifyEnclaveResponseSignature(uncompressedEnclavePubKey, body + response, signature, reject);
            // Create the Wallet object
            const responseJson = JSON.parse(response);
            const id = responseJson["walletId"];
            const blob = responseJson["blob"];
            const wallet = new CloudWallet(id, signingKey, decryptBlob(blob, aes_key), client);
            resolve(wallet);
        });
    }
    static verifyEnclaveResponseSignature(uncompressedEnclavePubKey, body, signature, reject) {
        const secp256k1 = new elliptic.ec("secp256k1");
        const enclavePubKey = secp256k1.keyFromPublic(uncompressedEnclavePubKey, "hex");
        const enclaveSignatureVerified = utils._verifySignature(enclavePubKey, body, signature);
        if (!enclaveSignatureVerified) {
            reject("Could not verify enclave's signature on the response");
        }
    }
    static async verifyAttestationReport(client, reject) {
        const report = await client.getAttestationReport();
        const pcr0s = (await client.getVerifiedPCR0s()).map(value => value["pcr0"]);
        const reportVerified = await utils._verifyAttestationReportAndEnclavePublicKey(report["report"], pcr0s);
        if (!reportVerified) {
            reject("Could not verify attestation report");
        }
        return report;
    }
    /**
     * Have a payload remotely signed with the wallet private key
     * @param payload The bytes to be signed. Note: this is the actual payload to be signed, NOT the hash of the payload
     * @returns The signature encoded in hexadecimal
    */
    async signPayload(payload) {
        console.log("CloudWallet.signPayload()");
        const __ret = await this.reEncryptedBlob();
        let user_id = __ret.user_id;
        let reEncryptedBlob = __ret.reEncryptedBlob;
        // build request and sign
        const body = utils._buildRpcBody("eth_signPayload", [user_id, '0x' + payload.toString("hex")]);
        const { request, signature } = await this.signRequest(body);
        const res = await this.client.sendSignedRequest(request, signature, reEncryptedBlob.toString("hex"), "rpc");
        const json = await res.json();
        return Promise.resolve(json["result"]);
    }
    async signRequest(body) {
        console.log("CloudWallet.signRequest()");
        const request = JSON.stringify(body);
        const digestToSign = crypto.createHash('sha256').update(Buffer.from(request)).digest("hex");
        const signature = await this.signingKey.sign(digestToSign);
        return { request, signature };
    }
    async reEncryptedBlob() {
        const enclavePublicKey = await this.client.getEnclavePubKey();
        // re-encrypt our blob
        let blob = Buffer.from(this.blob, "hex");
        let cpk_len = blob[34];
        let user_id_len = blob[35 + cpk_len];
        let user_id = user_id_len ? blob.subarray(36 + cpk_len, user_id_len) + "" : 0;
        const encryptedBlob = Buffer.from(this.blob, "hex").subarray(36 + cpk_len + user_id_len);
        // re-encrypt for enclave
        var reEncryptedBlob = ecies.encrypt(enclavePublicKey, encryptedBlob);
        reEncryptedBlob = Buffer.concat([Buffer.from(this.blob, "hex").subarray(0, 36 + cpk_len + user_id_len), reEncryptedBlob]);
        return { user_id, reEncryptedBlob };
    }
    /**
     * Get the xpub for this wallet
     * @returns The xpub encoded in hexadecimal
     */
    async getXPub(accountId) {
        console.log("CloudWallet.getXPub()");
        const __ret = await this.reEncryptedBlob();
        let reEncryptedBlob = __ret.reEncryptedBlob;
        let blob = reEncryptedBlob.toString("hex");
        // build request and sign
        const body = { path: `m/44'/60'/0'/0/${accountId}` };
        // For Web2 Cloudwallet, no signature is required to get the XPub
        // const { request, signature } = await this.signRequest(body);
        const request = JSON.stringify(body);
        const signature = "DEADBEEF"; // signature is ignored, we just specify a dummy here
        const report = await CloudWallet.verifyAttestationReport(this.client, reason => { return Promise.reject(reason); });
        const res = await this.client.sendSignedRequest(request, signature, blob, "wallets/xpub");
        const response = await res.text();
        const responseSig = res.headers.get("X-Enclave-Signature") + "";
        const uncompressedEnclavePubKey = utils._compressedToUncompressedPubKey(report["publicKey"]);
        CloudWallet.verifyEnclaveResponseSignature(uncompressedEnclavePubKey, request + response + blob, responseSig, reason => { return Promise.reject(reason); });
        return Promise.resolve(JSON.parse(response)["xpub"]);
    }
    async getMnemonic() {
        return new Promise(async (resolve, reject) => {
            const __ret = await this.reEncryptedBlob();
            let reEncryptedBlob = __ret.reEncryptedBlob;
            let blob = reEncryptedBlob.toString("hex");
            // Now start the actual wallet creation...
            // Get the attestation report and verify it
            const report = await CloudWallet.verifyAttestationReport(this.client, reject);
            const uncompressedEnclavePubKey = utils._compressedToUncompressedPubKey(report["publicKey"]);
            // build encKey header
            const aes_key = crypto.randomBytes(32);
            const req_encKey = ecies.encrypt(uncompressedEnclavePubKey, aes_key).toString("hex");
            // build signature header
            const digestToSign = crypto.createHash('sha256').update(Buffer.from(req_encKey)).digest("hex");
            const signature = await this.signingKey.sign(digestToSign);
            // Use the client to make the REST call
            const res = await this.client.getMnemonic(signature, blob, req_encKey);
            const response = await res.text();
            const secret = Buffer.from(JSON.parse(response).secret, 'hex');
            const resp_signature = res.headers.get("X-Enclave-Signature") + "";
            // Verify enclave response signature
            //CloudWallet.verifyEnclaveResponseSignature(uncompressedEnclavePubKey, response, resp_signature, reject);
            const nonce = Buffer.from('000000000000000000000000', 'hex');
            var decipher = crypto.createDecipheriv('aes-256-gcm', aes_key, nonce);
            console.log('aes_key = ' + aes_key.toString('hex'));
            const decrypted = JSON.parse(decipher.update(secret.subarray(0, secret.length - 16)));
            console.log('decrypted=' + decrypted);
            //decipher.setAAD(null);
            decipher.setAuthTag(secret.subarray(secret.length - 16));
            decipher.final();
            resolve(decrypted);
        });
    }
    /**
     * Obtain a signed transaction for transfering a certain amount of ERC20 tokens to a given address.
     * @param to Destination address
     * @param amount Amount to be transferred. Note: if the contract is for USDC and the amount is 1, this means transfering 1 USDC. The code will internally figure out the correct value based on the contract's decimals
     * @param contractAddress The address of the ERC20 contract
     * @returns The signed transaction, ready to be submitted via a provider
     */
    /*
    async getSignedTransactionForErc20Transfer(to: string, amount: string, contractAddress: string): Promise<string> {
        const erc20 = new Contract(contractAddress, erc20Abi, this);
        const contractDecimals = await erc20.decimals();
        const contractAmount = parseUnits(amount, contractDecimals).toString();
        const _unsignedTx = await erc20.populateTransaction.transfer(to, contractAmount);

        // fill in all the fields, like nonce, gas price, etc.
        const unsignedTx = await this.populateTransaction(_unsignedTx);
        return this.signTransaction(unsignedTx);
    }
*/
    /**
     * Transfer a certain amount of ERC20 tokens to a given address. Note: this internally signs AND submits the transaction.
     * @param to Destination address
     * @param amount Amount to be transferred. Note: if the contract is for USDC and the amount is 1, this means transfering 1 USDC. The code will internally figure out the correct value based on the contract's decimals
     * @param contractAddress The address of the ERC20 contract
     */
    /*
    async signAndSubmitErc20Transfer(to: string, amount: string, contractAddress: string) {
        const erc20 = new Contract(contractAddress, erc20Abi, this);
        const contractDecimals = await erc20.decimals();
        const contractAmount = parseUnits(amount, contractDecimals).toString();
        const tx = await erc20.transfer(to, contractAmount);
        return tx.wait();
    }
*/
    /**
     * Estimate the total value of this wallet in USD, on a specific chain.
     * This takes into account the holdings in native tokens (e.g., ETH, MATIC) and ERC20 tokens (e.g., USDC, USDT) on that chain.
     * @param chainId The ID of the chain
     * @returns The estimated value of the wallet, in USD
     */
    async getTotalWalletValueInUSD(chainId) {
        let totalUSDValue = 0;
        let address = await this.ethGetAddress(0);
        // Native token
        const nativeBalance = await CloudWallet.getWalletContentNative(address, chainId);
        totalUSDValue += nativeBalance.usd;
        // ERC20 tokens
        const tokens = await CloudWallet.getWalletContentErc20(address, chainId);
        for (const token of tokens) {
            totalUSDValue += token.usd;
        }
        return Promise.resolve(totalUSDValue);
    }
    /**
     * Get the native tokens balance of a wallet for a certain chain
     * @param chainId The ID of the chain
     * @param includeUSD Whether the USD value should be returned
     * @returns A TokenBalance object
     */
    static async getWalletContentNative(address, chainId, includeUSD = true) {
        // First, figure out the native token for this chain
        const nativeToken = utils.getNativeTokenForChain(chainId);
        if (nativeToken == '') {
            return Promise.reject("Cannot get value in USD for this chain");
        }
        // Try to start Moralis and ignore errors
        try {
            await moralis_1.default.start({
                apiKey: utils.MORALIS_API_KEY,
            });
        }
        catch (e) { }
        const resolvedChain = moralis_1.default.EvmUtils.EvmChain.create(chainId);
        const response = await moralis_1.default.EvmApi.balance.getNativeBalance({
            address: address,
            chain: resolvedChain,
        });
        const balance = parseInt(response.toJSON()["balance"]); // in wei
        let usd = 0;
        if (utils.hasChainUSDSupport(chainId) && includeUSD) {
            try {
                const exchangeRate = await utils.getNativeTokenPriceInUsd(nativeToken);
                usd = exchangeRate * balance / Math.pow(10, 18);
            }
            catch (e) { } // Skip the dollar amount on error
        }
        return Promise.resolve({
            chainId,
            type: 'native',
            symbol: nativeToken,
            balance,
            usd
        });
    }
    /**
     * Get the ERC20 balance of a wallet for a certain chain
     * @param address The address of the wallet
     * @param chainId The ID of the chain
     * @returns An array of TokenBalance objects
     */
    static async getWalletContentErc20(address, chainId) {
        // Try to start Moralis and ignore errors
        try {
            await moralis_1.default.start({
                apiKey: utils.MORALIS_API_KEY,
            });
        }
        catch (e) { }
        const resolvedChain = moralis_1.default.EvmUtils.EvmChain.create(chainId);
        const response = await moralis_1.default.EvmApi.token.getWalletTokenBalances({
            address: address,
            chain: resolvedChain,
        });
        const result = [];
        const items = response.toJSON();
        for (const item of items) {
            // Get the value
            const balance = parseInt(item["balance"]);
            let usd = 0;
            if (utils.hasChainUSDSupport(chainId)) {
                try {
                    const exchangeRate = await utils.getERC20TokenPriceInUSD(item["token_address"], chainId);
                    usd = exchangeRate * balance / Math.pow(10, item["decimals"]);
                }
                catch (e) { } // skip the dollar amount on error
            }
            const tokenBalance = {
                chainId,
                type: 'erc20',
                contract: item["token_address"],
                name: item["name"],
                symbol: item["symbol"],
                decimals: item["decimals"],
                balance,
                usd
            };
            result.push(tokenBalance);
        }
        return Promise.resolve(result);
    }
}
exports.CloudWallet = CloudWallet;
